import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import LoadingPage from "../../../Components/layouts/loading";
import { ClientProjectHandoverInfo } from "../../../SchemaInfo/info";
import { getId } from "../../../Components/Functions/word.fun";
import { ClientProjectHandoverSchema } from "../../../Schemas/clients/client_project_handover_schema";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcReading } from "react-icons/fc";

const AddProjectHandover = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  const navigate = useNavigate();
  const [siteInspections, setSiteInspections] = useState([]);

  useEffect(() => {
    performRequest("GET", "/siteInspection/getallSiteInspection")
      .then((res) => setSiteInspections(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values, actions) => {
    values = { ...values, generatedBy: store.Name };
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest("POST", "/handOver/createHandOver/", formData, headers)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Handover created successfully!");
          navigate(`/client-project-handover`);
        } else {
          Toast("error", "Error while creating handover!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcReading className="fs-2 me-1" />
                  Project Handover
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">New Handover</h2>
            </div>
            <Formik
              initialValues={ClientProjectHandoverInfo}
              validationSchema={ClientProjectHandoverSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Project
                      </label>

                      <div className="w-100 col">
                        <CustomSelect name="projectId" type="number">
                          <option value="">Select project</option>
                          {projects &&
                            projects?.map((pro) => {
                              return (
                                <option
                                  key={pro.cpNumber}
                                  value={getId(pro.cpNumber)}
                                >
                                  {pro.clientName}
                                </option>
                              );
                            })}
                        </CustomSelect>
                        {props.touched.projectId && props.errors.projectId && (
                          <p className="text-danger">
                            {props.errors.projectId}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Site inspection
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="siteSelectionId">
                          <option value="">Select</option>
                          {siteInspections &&
                            siteInspections?.map((si) => {
                              return (
                                <option key={si.siNumber} value={si.siNumber}>
                                  {si.clientName}
                                </option>
                              );
                            })}
                        </CustomSelect>

                        {props.touched.siteSelectionId &&
                          props.errors.siteSelectionId && (
                            <p className="text-danger">
                              {props.errors.siteSelectionId}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label ">Handover date</label>
                      <div className="w-100 col">
                        <CustomInput name="handOverDate" type="date" />
                        {props.touched.handOverDate &&
                          props.errors.handOverDate && (
                            <p className="text-danger">
                              {props.errors.handOverDate}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr className="m-0 p-2"></hr>
                    <h3 className="pb-1">CEA </h3>
                    <hr className="m-0 p-2"></hr>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Cabin Outside Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaCabinOutsidePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaCabinOutsidePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaCabinOutsidePhoto &&
                          props.errors.ceaCabinOutsidePhoto && (
                            <p className="text-danger">
                              {props.errors.CEA?.ceaCabinOutsidePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Outside Gutter Side Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaOutsideGutterSidePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaOutsideGutterSidePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaOutsideGutterSidePhoto &&
                          props.errors.ceaOutsideGutterSidePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaOutsideGutterSidePhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Outside Non-Gutter Side Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaOutsideNonGutterSidePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaOutsideNonGutterSidePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaOutsideNonGutterSidePhoto &&
                          props.errors.ceaOutsideNonGutterSidePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaOutsideNonGutterSidePhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Gutter Side Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaGutterSidePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaGutterSidePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaGutterSidePhoto &&
                          props.errors.ceaGutterSidePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaGutterSidePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Non-Gutter Side Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaNonGutterSidePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaNonGutterSidePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaNonGutterSidePhoto &&
                          props.errors.ceaNonGutterSidePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaNonGutterSidePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Side 1 Vent Handle Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaSide1VentHandlePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaSide1VentHandlePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaSide1VentHandlePhoto &&
                          props.errors.ceaSide1VentHandlePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaSide1VentHandlePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Side 2 Vent Handle Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaSide2VentHandlePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaSide2VentHandlePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaSide2VentHandlePhoto &&
                          props.errors.ceaSide2VentHandlePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaSide2VentHandlePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Side 3 Vent Handle Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaSide3VentHandlePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaSide3VentHandlePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaSide3VentHandlePhoto &&
                          props.errors.ceaSide3VentHandlePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaSide3VentHandlePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Side 4 Vent Handle Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaSide4VentHandlePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaSide4VentHandlePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaSide4VentHandlePhoto &&
                          props.errors.ceaSide4VentHandlePhoto && (
                            <p className="text-danger">
                              {props.errors.ceaSide4VentHandlePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Shade Net Closed Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaShadeNetClosedPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaShadeNetClosedPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaShadeNetClosedPhoto &&
                          props.errors.ceaShadeNetClosedPhoto && (
                            <p className="text-danger">
                              {props.errors.ceaShadeNetClosedPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Shade Net Open Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaShadeNetOpenPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaShadeNetOpenPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaShadeNetOpenPhoto &&
                          props.errors.ceaShadeNetOpenPhoto && (
                            <p className="text-danger">
                              {props.errors.ceaShadeNetOpenPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA Weedmat Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaWeedmatPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaWeedmatPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaWeedmatPhoto &&
                          props.errors.ceaWeedmatPhoto && (
                            <p className="text-danger">
                              {props.errors.ceaWeedmatPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA ACF Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaAcfPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaAcfPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaAcfPhoto &&
                          props.errors.ceaAcfPhoto && (
                            <p className="text-danger">
                              {props.errors.ceaAcfPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr className="m-0 p-2"></hr>
                    <h3 className="pb-1">Fogger Assembly</h3>
                    <hr className="m-0 p-2"></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fogger Tank Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="foggerTankPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "foggerTankPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.foggerTankPhoto &&
                          props.errors.foggerTankPhoto && (
                            <p className="text-danger">
                              {props.errors.foggerTankPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fogger Motor Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="foggerMotorPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "foggerMotorPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.foggerMotorPhoto &&
                          props.errors.foggerMotorPhoto && (
                            <p className="text-danger">
                              {props.errors.foggerMotorPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fogger Disk Filter Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="foggerDiskFilterPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "foggerDiskFilterPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.foggerDiskFilterPhoto &&
                          props.errors.foggerDiskFilterPhoto && (
                            <p className="text-danger">
                              {props.errors.foggerDiskFilterPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fogger Take Off Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="foggerTakeOffPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "foggerTakeOffPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.foggerTakeOffPhoto &&
                          props.errors.foggerTakeOffPhoto && (
                            <p className="text-danger">
                              {props.errors.foggerTakeOffPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fogger On State Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="foggerOnStatePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "foggerOnStatePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.foggerOnStatePhoto &&
                          props.errors.foggerOnStatePhoto && (
                            <p className="text-danger">
                              {props.errors.foggerOnStatePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fogger Timer Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="foggerTimerPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "foggerTimerPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.foggerTimerPhoto &&
                          props.errors.foggerTimerPhoto && (
                            <p className="text-danger">
                              {props.errors.foggerTimerPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr className="m-0 p-2"></hr>
                    <h3 className="pb-1">Flatbed (Hydroponics)</h3>
                    <hr className="m-0 p-2"></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        FlatBed Pipes Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedPipesPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedPipesPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedPipesPhoto &&
                          props.errors.flatbedPipesPhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedPipesPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Frame Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedFramePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedFramePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedFramePhoto &&
                          props.errors.flatbedFramePhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedFramePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Water Tank Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedWaterTankPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedWaterTankPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedWaterTankPhoto &&
                          props.errors.flatbedWaterTankPhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedWaterTankPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Water Tank Inlet Valve Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedWaterTankInletValvePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedWaterTankInletValvePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedWaterTankInletValvePhoto &&
                          props.errors.flatbedWaterTankInletValvePhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedWaterTankInletValvePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Water Pump Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedWaterPumpPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedWaterPumpPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedWaterPumpPhoto &&
                          props.errors.flatbedWaterPumpPhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedWaterPumpPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Water Recollection Pipe Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedWaterRecollectionPipePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedWaterRecollectionPipePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedWaterRecollectionPipePhoto &&
                          props.errors.flatbedWaterRecollectionPipePhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedWaterRecollectionPipePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Netcup Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedNetcupPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedNetcupPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedNetcupPhoto &&
                          props.errors.flatbedNetcupPhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedNetcupPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Water Flow From R/O Pipe Photo (Last NFT Pipe)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedWaterFlowFromRoPipePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedWaterFlowFromRoPipePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedWaterFlowFromRoPipePhoto &&
                          props.errors.flatbedWaterFlowFromRoPipePhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedWaterFlowFromRoPipePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Net Cup Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedNetCupPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedNetCupPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedNetCupPhoto &&
                          props.errors.flatbedNetCupPhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedNetCupPhoto}
                            </p>
                          )}
                      </div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Timer Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedTimerPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedTimerPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedTimerPhoto &&
                          props.errors.flatbedTimerPhoto && (
                            <p className="text-danger">
                              {props.errors.flatbedTimerPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr className="m-0 p-2"></hr>
                    <h3 className="pb-1">Growbags (Hydroponics)</h3>
                    <hr className="m-0 p-2"></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags Tank Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsTankPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsTankPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsTankPhoto &&
                          props.errors.growbagsTankPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsTankPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags Motor Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsMotorPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsMotorPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsMotorPhoto &&
                          props.errors.growbagsMotorPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsMotorPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags Disk Filter Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsDiskFilterPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsDiskFilterPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsDiskFilterPhoto &&
                          props.errors.growbagsDiskFilterPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsDiskFilterPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags TakeOff Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsTakeOffPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsTakeOffPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsTakeOffPhoto &&
                          props.errors.growbagsTakeOffPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsTakeOffPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags On State Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsOnStatePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsOnStatePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsOnStatePhoto &&
                          props.errors.growbagsOnStatePhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsOnStatePhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags Arrow Dripper Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsArrowDripperPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsArrowDripperPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsArrowDripperPhoto &&
                          props.errors.growbagsArrowDripperPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsArrowDripperPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags Drip pipe End Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsDripPipeEndPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsDripPipeEndPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsDripPipeEndPhoto &&
                          props.errors.growbagsDripPipeEndPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsDripPipeEndPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags Timer Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsTimerPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsTimerPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsTimerPhoto &&
                          props.errors.growbagsTimerPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagsTimerPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbag Trellesing Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagTrellisingPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagTrellisingPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagTrellisingPhoto &&
                          props.errors.growbagTrellisingPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagTrellisingPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbag J-Hook Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagJHookPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagJHookPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagJHookPhoto &&
                          props.errors.growbagJHookPhoto && (
                            <p className="text-danger">
                              {props.errors.growbagJHookPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr className="m-0 p-2"></hr>
                    <h3 className="pb-1">Upload Videos</h3>
                    <hr className="m-0 p-2"></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        CEA outside assembly video (1Min max)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ceaOutsideAssemblyVideo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ceaOutsideAssemblyVideo",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ceaOutsideAssemblyVideo &&
                          props.errors.ceaOutsideAssemblyVideo && (
                            <p className="text-danger">
                              {props.errors.ceaOutsideAssemblyVideo}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Side Vent Operating video (1Min max)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="sideVentOperatingVideo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "sideVentOperatingVideo",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.sideVentOperatingVideo &&
                          props.errors.sideVentOperatingVideo && (
                            <p className="text-danger">
                              {props.errors.sideVentOperatingVideo}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Entering inside CEA video (1Min max)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="enteringInsideCeaVideo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "enteringInsideCeaVideo",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.enteringInsideCeaVideo &&
                          props.errors.enteringInsideCeaVideo && (
                            <p className="text-danger">
                              {props.errors.enteringInsideCeaVideo}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Flatbed Entire Assembly video (1Min max)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="flatbedEntireAssemblyVideo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "flatbedEntireAssemblyVideo",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.flatbedEntireAssemblyVideo &&
                          props.errors.flatbedEntireAssemblyVideo && (
                            <p className="text-danger">
                              {props.errors.flatbedEntireAssemblyVideo}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Growbags Entire Assembly video (1Min max)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="growbagsEntireAssemblyVideo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "growbagsEntireAssemblyVideo",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.growbagsEntireAssemblyVideo &&
                          props.errors.growbagsEntireAssemblyVideo && (
                            <p className="text-danger">
                              {props.errors.growbagsEntireAssemblyVideo}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr></hr>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Client Photo With Handover Document.
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="customerPhotoWithSetUp"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "customerPhotoWithSetUp",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.customerPhotoWithSetUp &&
                          props.errors.customerPhotoWithSetUp && (
                            <p className="text-danger">
                              {props.errors.customerPhotoWithSetUp}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Handover Document Photo (Signed by Client)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="handOverCertificate"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "handOverCertificate",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.handOverCertificate &&
                          props.errors.handOverCertificate && (
                            <p className="text-danger">
                              {props.errors.handOverCertificate}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Customer feedback video
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="customerFeedbackVideo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "customerFeedbackVideo",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.customerFeedbackVideo &&
                          props.errors.customerFeedbackVideo && (
                            <p className="text-danger">
                              {props.errors.customerFeedbackVideo}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        North south measurment in meter
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="northSouthMeasurmentInMeter"
                          type="text"
                        />
                        {props.touched.northSouthMeasurmentInMeter &&
                          props.errors.northSouthMeasurmentInMeter && (
                            <p className="text-danger">
                              {props.errors.northSouthMeasurmentInMeter}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        North south measurment photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="northSouthMeasurmentPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "northSouthMeasurmentPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.northSouthMeasurmentPhoto &&
                          props.errors.northSouthMeasurmentPhoto && (
                            <p className="text-danger">
                              {props.errors.northSouthMeasurmentPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        East west measurment in meter
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="eastWestMeasurmentInMeter"
                          type="text"
                        />
                        {props.touched.eastWestMeasurmentInMeter &&
                          props.errors.eastWestMeasurmentInMeter && (
                            <p className="text-danger">
                              {props.errors.eastWestMeasurmentInMeter}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        East west measurment photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="eastWestMeasurmentPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "eastWestMeasurmentPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.eastWestMeasurmentPhoto &&
                          props.errors.eastWestMeasurmentPhoto && (
                            <p className="text-danger">
                              {props.errors.eastWestMeasurmentPhoto}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Description video
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"file"}
                          name="descriptionVideo"
                          onChange={(e) =>
                            props.setFieldValue(
                              "descriptionVideo",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.descriptionVideo &&
                          props.errors.descriptionVideo && (
                            <p className="text-danger">
                              {props.errors.descriptionVideo}
                            </p>
                          )}
                      </div>
                    </div> */}

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Tank photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="overheadTankPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "overheadTankPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.overheadTankPhoto &&
                          props.errors.overheadTankPhoto && (
                            <p className="text-danger">
                              {props.errors.overheadTankPhoto}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        A-Frame photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="aFramePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "aFramePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.aFramePhoto &&
                          props.errors.aFramePhoto && (
                            <p className="text-danger">
                              {props.errors.aFramePhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Net-cup photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="netCupPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "netCupPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.netCupPhoto &&
                          props.errors.netCupPhoto && (
                            <p className="text-danger">
                              {props.errors.netCupPhoto}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        A-Frame foundation photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="aFrameFoundationPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "aFrameFoundationPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.aFrameFoundationPhoto &&
                          props.errors.aFrameFoundationPhoto && (
                            <p className="text-danger">
                              {props.errors.aFrameFoundationPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vent opener photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="ventOpenerPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "ventOpenerPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.ventOpenerPhoto &&
                          props.errors.ventOpenerPhoto && (
                            <p className="text-danger">
                              {props.errors.ventOpenerPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Aluminium shade net fully photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="aluminiumShadeNetPullyPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "aluminiumShadeNetPullyPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.aluminiumShadeNetPullyPhoto &&
                          props.errors.aluminiumShadeNetPullyPhoto && (
                            <p className="text-danger">
                              {props.errors.aluminiumShadeNetPullyPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Exhaust fan photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="exhaustFanPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "exhaustFanPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.exhaustFanPhoto &&
                          props.errors.exhaustFanPhoto && (
                            <p className="text-danger">
                              {props.errors.exhaustFanPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        East-West measurment photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="eastWestMeasurmentPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "eastWestMeasurmentPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.eastWestMeasurmentPhoto &&
                          props.errors.eastWestMeasurmentPhoto && (
                            <p className="text-danger">
                              {props.errors.eastWestMeasurmentPhoto}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Celluse pad photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="cellusePadPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "cellusePadPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.cellusePadPhoto &&
                          props.errors.cellusePadPhoto && (
                            <p className="text-danger">
                              {props.errors.cellusePadPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Water pump photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="waterPumpPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "waterPumpPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.waterPumpPhoto &&
                          props.errors.waterPumpPhoto && (
                            <p className="text-danger">
                              {props.errors.waterPumpPhoto}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Water pump drainage photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="waterPumpDrainagePhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "waterPumpDrainagePhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.waterPumpDrainagePhoto &&
                          props.errors.waterPumpDrainagePhoto && (
                            <p className="text-danger">
                              {props.errors.waterPumpDrainagePhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Oxigenation pump photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="oxigenationPumpPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "oxigenationPumpPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.oxigenationPumpPhoto &&
                          props.errors.oxigenationPumpPhoto && (
                            <p className="text-danger">
                              {props.errors.oxigenationPumpPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        UV light photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="uvLightPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "uvLightPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.uvLightPhoto &&
                          props.errors.uvLightPhoto && (
                            <p className="text-danger">
                              {props.errors.uvLightPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Disk filter photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="diskFilterPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "diskFilterPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.diskFilterPhoto &&
                          props.errors.diskFilterPhoto && (
                            <p className="text-danger">
                              {props.errors.diskFilterPhoto}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Sand filter photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="sandFilterPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "sandFilterPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.sandFilterPhoto &&
                          props.errors.sandFilterPhoto && (
                            <p className="text-danger">
                              {props.errors.sandFilterPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fogger assembly photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="foggerAssemblyPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "foggerAssemblyPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.foggerAssemblyPhoto &&
                          props.errors.foggerAssemblyPhoto && (
                            <p className="text-danger">
                              {props.errors.foggerAssemblyPhoto}
                            </p>
                          )}
                      </div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Notes</label>
                      <div className="w-100 col">
                        <CustomTextArea
                          name="notes"
                          type="textarea"
                          rows={"10"}
                        ></CustomTextArea>
                        {props.touched.notes && props.errors.notes && (
                          <p className="text-danger">{props.errors.notes}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create Handover" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default AddProjectHandover;
